module.exports = __webpack_public_path__ + "static/media/5.bd2ad19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/5.png
// module id = 1213
// module chunks = 0